/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import * as vp from 'vopay';
import ReactMarkdown from 'react-markdown';
import { FunctionComponent, useEffect, useState } from 'react';
import styles from './TicketComments.module.scss';
import { usePartnerLogin } from '../../../providers/PartnerLogin.provider';
import { useTranslation } from 'react-i18next';

const { Box, SubTitle, Button } = vp;

type TicketDetialsProps = {
  ticketDetail: vp.TicketDetailsResponse;
  refreshHighlight: boolean;
};
type CommentWithContentURL = vp.TicketComment & {
  files: vp.TicketComment[];
};
type FC = FunctionComponent<TicketDetialsProps>;

const TicketComments: FC = (props: TicketDetialsProps) => {
  const { ticketDetail, refreshHighlight } = props;
  const [visible, setVisible] = useState(false);
  const [isPaginated, setIsPaginated] = useState(true);
  const [ticketComments, setTicketComments] = useState<CommentWithContentURL[]>([]);
  const [ticketCommentsFirst, setTicketCommentFirst] = useState<CommentWithContentURL>();
  const { response } = usePartnerLogin();
  const { t } = useTranslation('translations', { keyPrefix: 'Tickets.Details' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global.Buttons' });

  useEffect(() => {
    const originalTickets = Object.values(ticketDetail.Ticket.ticketComments || {});
    const shrunkenList = originalTickets.reduce((acc: CommentWithContentURL[], comment: vp.TicketComment) => {
      // Zendesk omits the 0-indexed comment when a ticket's first comment is internal, which can
      // leave undefined entries (and comments missing the `comment` field). Skip/guard them so the
      // ticket view doesn't blank out.
      if (!comment) return acc;
      if (comment.content_url !== null) {
        if (acc[acc.length - 1]) {
          if (!(comment.comment || '').startsWith('File Attachment:')) {
            acc.push({ ...comment, files: [{ ...comment, content_url: comment.content_url, comment: '' }] });
          } else {
            acc[acc.length - 1].files.push(comment);
          }
        } else if (!(comment.comment || '').startsWith('File Attachment:')) {
          acc.push({ ...comment, files: [{ ...comment, content_url: comment.content_url, comment: '' }] });
        }
      } else {
        acc.push({ ...comment, files: [] });
      }
      return acc;
    }, [] as CommentWithContentURL[]);
    const firstItem = shrunkenList[0];
    setTicketCommentFirst(firstItem);
    const removedList = shrunkenList.slice(1);
    setTicketComments(removedList);
  }, [ticketDetail]);
  useEffect(() => {
    if (refreshHighlight) {
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 8000);
    }
  }, [refreshHighlight]);
  return (
    <div>
      {ticketDetail.Success && (
        <>
          <div>
            <Box mt="sm" mb="md" flx="col" pt="sm" ps="sm" pe="sm" pb="sm" background="grey" wrap="wrap" r="md">
              <Box mb="smmd" jc="sb" ai="center">
                <Box ai="center">
                  <SubTitle
                    subTitle={getNameForTicket(ticketCommentsFirst?.email || '', response.accountId)}
                    variant="small"
                  />
                </Box>
                <Box ai="center">
                  <div className={styles.CommentDate}>{ticketCommentsFirst?.created_at || ''}</div>
                </Box>
              </Box>
              <Box flx="col">
                <div className={styles.CommentDescription}>
                  {' '}
                  <ReactMarkdown>{ticketCommentsFirst?.comment || ''}</ReactMarkdown>
                </div>
                {ticketCommentsFirst && ticketCommentsFirst?.files.length > 0 && (
                  <ul className={styles.filesList}>
                    {ticketCommentsFirst?.files.map((file, indexFile) => (
                      <li key={`comment--0-file-${indexFile}`}>
                        <Box gap="sm" ai="center">
                          {getFileNameFromUrl(file.content_url || '')}
                          <Button
                            id={`comment--0-file-${indexFile}-button`}
                            label={tGlobal('download')}
                            color="secondary"
                            height="28px"
                            fontUnit="px"
                            textSize={14}
                            onClick={() => {
                              // Create a temporary anchor element
                              const anchor = document.createElement('a');
                              anchor.href = file.content_url || '';
                              anchor.target = '_blank'; // Open the link in a new tab/window

                              // Append the anchor element to the document body
                              document.body.appendChild(anchor);

                              // Trigger a click event on the anchor element to start the download
                              anchor.click();

                              // Remove the temporary anchor element after a short delay
                              setTimeout(() => {
                                document.body.removeChild(anchor);
                              }, 100);
                            }}
                          />
                        </Box>
                      </li>
                    ))}
                  </ul>
                )}
              </Box>
            </Box>
          </div>
          {ticketComments.length > 3 && isPaginated && (
            <div className={styles.lineContainer}>
              <div className={styles.line} />
              <div className={styles.buttonContainer}>
                <Button
                  id="loadmore"
                  type="button"
                  label={t('olderMessages', { count: ticketComments.length - 2 })}
                  onClick={() => {
                    setIsPaginated(false);
                  }}
                  color="secondary"
                  height="20px"
                  fontUnit="px"
                  textSize={14}
                />
              </div>
            </div>
          )}
          {(isPaginated && ticketComments.length > 3 ? ticketComments.slice(-2) : ticketComments).map(
            (comment, indexComment) => (
              <div key={String(indexComment)}>
                <Box mt="sm" mb="md" flx="col" pt="sm" ps="sm" pe="sm" pb="sm" background="grey" wrap="wrap" r="md">
                  <Box
                    mb="smmd"
                    ps={showHighlight(ticketComments, visible, isPaginated, indexComment) && visible ? 'sm' : undefined}
                    pe={showHighlight(ticketComments, visible, isPaginated, indexComment) ? 'sm' : undefined}
                    r="sm"
                    jc="sb"
                    ai="center"
                    background={
                      showHighlight(ticketComments, visible, isPaginated, indexComment) ? 'yellow' : undefined
                    }
                  >
                    <Box ai="center">
                      <SubTitle subTitle={getNameForTicket(comment?.email || '', response.accountId)} variant="small" />
                    </Box>
                    <Box ai="center">
                      <div className={styles.CommentDate}>{comment?.created_at || ''}</div>
                    </Box>
                  </Box>
                  <Box flx="col">
                    <div className={styles.CommentDescription}>
                      {' '}
                      <ReactMarkdown>{comment?.comment || ''}</ReactMarkdown>
                    </div>
                    {comment?.files.length > 0 && (
                      <ul className={styles.filesList}>
                        {comment?.files.map((file, indexFile) => (
                          <li key={`comment-${indexComment}-file-${indexFile}`}>
                            <Box gap="sm" ai="center">
                              {getFileNameFromUrl(file.content_url || '')}
                              <Button
                                id={`comment-${indexComment}-file-${indexFile}-button`}
                                label={tGlobal('download')}
                                color="secondary"
                                height="28px"
                                fontUnit="px"
                                textSize={14}
                                onClick={() => {
                                  // Create a temporary anchor element
                                  const anchor = document.createElement('a');
                                  anchor.href = file.content_url || '';
                                  anchor.target = '_blank'; // Open the link in a new tab/window

                                  // Append the anchor element to the document body
                                  document.body.appendChild(anchor);

                                  // Trigger a click event on the anchor element to start the download
                                  anchor.click();

                                  // Remove the temporary anchor element after a short delay
                                  setTimeout(() => {
                                    document.body.removeChild(anchor);
                                  }, 100);
                                }}
                              />
                            </Box>
                          </li>
                        ))}
                      </ul>
                    )}
                  </Box>
                </Box>
              </div>
            ),
          )}
          <div className={styles.Bar} />
        </>
      )}
    </div>
  );
};

function getNameForTicket(str: string, accountName: string): string {
  if (str.includes('@vopay.com')) {
    // Remove the prefix and trim any extra spaces
    return 'VoPay Helpdesk';
  }
  return `${str} (${accountName})`;
}
function showHighlight(
  comments: CommentWithContentURL[],
  visible: boolean,
  isPaginated: boolean,
  index: number,
): boolean {
  if (isPaginated && comments.length > 3) {
    return visible && comments.slice(-2).length - 1 === index;
  }

  return visible && comments.length - 1 === index;
}
function getFileNameFromUrl(url: string): string {
  const urlObj = new URL(url);
  const searchParams = new URLSearchParams(urlObj.search);
  return searchParams.get('name') || '';
}
export default TicketComments;
